import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { useEmbeddedNavigation } from '../hooks/useEmbeddedMode.js';
import Button from '../ui/Button.jsx';
import Input from '../ui/Input.jsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/Card.jsx';

export default function LoginPage() {
  const { login } = useAuth();
  const { navigateEmbedded, toEmbeddedPath } = useEmbeddedNavigation();
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      await login({ email, password });
      navigateEmbedded('/', { replace: true });
    } catch (err) {
      setError(err?.message || 'Login failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-full flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <Card className="overflow-hidden">
          <CardHeader>
            <div className="ptcm-section-pill w-fit">Connexion</div>
            <CardTitle className="mt-4 text-2xl">Bon retour</CardTitle>
            <CardDescription>
              Pas de compte ?{' '}
              <Link className="font-semibold text-ptcm-primary dark:text-blue-400 hover:underline" to={toEmbeddedPath('/signup')}>
                Créer un compte
              </Link>
              .
            </CardDescription>
          </CardHeader>
          <CardContent>
            {error ? (
              <div className="mb-4 rounded-2xl border border-red-200/70 bg-red-50/90 px-4 py-3 text-sm text-red-600 dark:bg-red-900/20 dark:text-red-300">
                {error}
              </div>
            ) : null}

            <form onSubmit={onSubmit} className="space-y-4 text-left">
              <div className="space-y-2">
                <label className="text-sm font-semibold text-ptcm-ink dark:text-gray-100" htmlFor="email">
                  Email
                </label>
                <Input id="email" name="email" type="email" placeholder="vous@exemple.com" required />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-semibold text-ptcm-ink dark:text-gray-100" htmlFor="password">
                  Mot de passe
                </label>
                <Input id="password" name="password" type="password" required />
              </div>

              <Button className="w-full" type="submit" size="xl" disabled={isSubmitting}>
                {isSubmitting ? 'Connexion...' : 'Se connecter'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

